module.exports = __webpack_public_path__ + "static/media/logo.d7f11603.png";